import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Navigation from "@/components/Navigation";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Offer } from "@/components/Offer";
import { Benefits } from "@/components/Benefits";
import { WhyUs } from "@/components/WhyUs";
import { FormsOfComedy } from "@/components/FormsOfComedy";
import { Testimonials } from "@/components/Testimonials";
import { ContactForm } from "@/components/ContactForm";
import { Footer } from "@/components/Footer";
import { VideoSection } from "@/components/VideoSection";

const Index = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Występy komediowe dla firm - Stand-up, Kabaret, Imprezy | WystepKomediowy.pl</title>
        <meta name="description" content="Profesjonalne występy komediowe dla firm i osób prywatnych. Stand-up, kabaret, imprezy firmowe. 999+ występów, 27 lat doświadczenia. Zamów występ!" />
        <link rel="canonical" href="https://wystepkomediowy.pl/" />
        <meta property="og:title" content="Występy komediowe dla firm - WystepKomediowy.pl" />
        <meta property="og:description" content="Profesjonalne występy komediowe dla firm i osób prywatnych. Stand-up, kabaret, imprezy firmowe. 999+ występów, 27 lat doświadczenia." />
        <meta property="og:url" content="https://wystepkomediowy.pl/" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="WystepKomediowy.pl" />
      </Helmet>
      <Navigation />
      <main>
        <Hero />
        <About />
        <Offer />
        <Benefits />
        <WhyUs />
        <FormsOfComedy />
        <VideoSection />
        <Testimonials />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
